import {createAsyncThunk} from '@reduxjs/toolkit'

import {KFTC_PERSONAL_INFO_CONCESSION_URL} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {ThunkApi} from '../interfaces'

/**
 * 금융결제원(Korea Fair Trad Commission) 개인정보 제공 동의 페이지로 이동
 */
const navigateToKFTCPersonalInfoConcession = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/KFTCPersonalInfoConsession',
    async () => {
        if (isMobile) {
            changeBrowserLocation({
                url: KFTC_PERSONAL_INFO_CONCESSION_URL,
                type: 'PUSH',
            })
        } else {
            openNewTab({url: KFTC_PERSONAL_INFO_CONCESSION_URL})
        }

        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToKFTCPersonalInfoConcession
